import React from 'react';
import UploadField from './FormFields/UploadField';
import InputField from './FormFields/InputField';
import CheckboxField from './FormFields/CheckboxField';
import DropdownField from './FormFields/DropdownField';
import DateSelectField from './FormFields/DateSelectField';
import TagField from './FormFields/TagField';
import PlainTextField from "./FormFields/PlainTextField";
import EmailField from "./FormFields/EmailField";
import MultiselectField from "./FormFields/MultiselectField";
import ReCaptchaField from "./FormFields/ReCaptchaField";
import BaseField from "./FormFields/BaseField";

export class FieldRenderer extends React.Component{
    constructor(props) {
        super(props);
    }

    renderFields(){
        return this.props.Fields.map((field, index) => {
            switch (field.Type) {
                case 'Upload': {
                    return <UploadField
                        key={index}
                        id={field.Key}
                        Label={field.Label}
                        Required={field.Required}
                        Columns={field.Columns}
                        Hint={field.Hint}
                        IconURL={field.IconURL}
                        IconClass={field.IconClass}
                        Files={field.Value}
                        AllowedMaxSize={field.AllowedMaxSize}
                        AllowedTypes={field.AllowedTypes}
                        AllowMultipleFiles={field.AllowMultipleFiles}
                        AllowedMaxFiles={field.AllowedMaxFiles}
                        collectData={(label,value) => {this.props.collectData(this.props.Key, label, value)}}
                        IsValid={field.IsValid}
                        ErrorMessage={field.ErrorMessage}
                        ErrorMessageWrongFormat={field.ErrorMessageWrongFormat}
                        ErrorMessageTooBig={field.ErrorMessageTooBig}
                        ErrorMessageTooManyFiles={field.ErrorMessageTooManyFiles}
                    />
                }
                case 'Text': {
                    return <InputField
                        key={index}
                        id={field.Key}
                        Label={field.Label}
                        Required={field.Required}
                        Columns={field.Columns}
                        Placeholder={field.Placeholder}
                        value={field.Value}
                        collectData={(label,value) => {this.props.collectData(this.props.Key, label, value)}}
                        trackInput={(label) => {this.props.trackInput(this.props.Title, label)}}
                        IsValid={field.IsValid}
                        ErrorMessage={field.ErrorMessage}
                    />
                }
                case 'Checkbox': {
                    return <CheckboxField
                        key={index}
                        id={field.Key}
                        Label={field.Label}
                        Required={field.Required}
                        Columns={field.Columns}
                        Placeholder={field.Placeholder}
                        value={field.Value}
                        collectData={(label,value) => {this.props.collectData(this.props.Key, label, value)}}
                        IsValid={field.IsValid}
                        ErrorMessage={field.ErrorMessage}
                    />
                }
                case 'PlainText': {
                    return <PlainTextField
                        key={index}
                        id={field.Key}
                        Text={field.Text}
                        Columns={field.Columns}
                    />
                }
                case 'Email': {
                    return <EmailField
                        key={index}
                        id={field.Key}
                        Label={field.Label}
                        Required={field.Required}
                        Columns={field.Columns}
                        Placeholder={field.Placeholder}
                        collectData={(label,value) => {this.props.collectData(this.props.Key, label, value)}}
                        trackInput={(label) => {this.props.trackInput(this.props.Title, label)}}
                        value={field.value}
                        IsValid={field.IsValid}
                        ErrorMessage={field.ErrorMessage}
                        ErrorMessageWrongFormat={field.ErrorMessageWrongFormat}
                    />
                }
                case 'MultiSelect': {
                    return <MultiselectField
                        key={index}
                        id={field.Key}
                        Label={field.Label}
                        Required={field.Required}
                        Columns={field.Columns}
                        Placeholder={field.Placeholder}
                        collectData={(label,value) => {this.props.collectData(this.props.Key, label, value)}}
                        Values={field.SelectableValues}
                        PreselectedValue={this.props.PreselectedValue}
                        InitiativeApplicationTitle={this.props.InitiativeApplicationTitle}
                        SaveText={this.props.SaveText}
                        CancelText={this.props.CancelText}
                        collectMultiSelectData={this.props.collectMultiSelectData}
                        IsValid={field.IsValid}
                        ErrorMessage={field.ErrorMessage}
                    />
                }
                case 'DateSelect': {
                    return <DateSelectField
                        key={index}
                        id={field.Key}
                        Label={field.Label}
                        Required={field.Required}
                        Columns={field.Columns}
                        PlaceholderDay={field.PlaceholderDay}
                        PlaceholderMonth={field.PlaceholderMonth}
                        PlaceholderYear={field.PlaceholderYear}
                        collectData={(label,value) => {this.props.collectData(this.props.Key, label, value)}}
                        value={field.value}
                        IsValid={field.IsValid}
                        ErrorMessage={field.ErrorMessage}
                    />
                }
                case 'Dropdown': {
                    return <DropdownField
                        key={index}
                        id={field.Key}
                        Label={field.Label}
                        Required={field.Required}
                        Columns={field.Columns}
                        Placeholder={field.Placeholder}
                        collectData={(label,value) => {this.props.collectData(this.props.Key, label, value)}}
                        Values={field.Items}
                        value={field.Value}
                        IsValid={field.IsValid}
                        ErrorMessage={field.ErrorMessage}
                    />
                }
                case 'MultipleItems': {
                    return <MultipleItemsField
                        key={index}
                        id={field.Key}
                        Label={field.Label}
                        Required={field.Required}
                        Columns={field.Columns}
                        Placeholder={field.Placeholder}
                        collectData={(label,value) => {this.props.collectData(this.props.Key, label, value)}}
                        trackInput={(label) => {this.props.trackInput(this.props.Title, label)}}
                        ButtonCaption={field.ButtonCaption}
                        ValueFor={field.ValueFor}
                        Template={field.Template}
                        Fields={field.Items}
                        IsValid={field.IsValid}
                        ErrorMessage={field.ErrorMessage}
                    />
                }
                case 'TagField': {
                    return <TagField
                        key={index}
                        id={field.Key}
                        Label={field.Label}
                        Required={field.Required}
                        Columns={field.Columns}
                        Placeholder={field.Placeholder}
                        collectData={(label,value) => {this.props.collectData(this.props.Key, label, value)}}
                        ButtonCaption={field.ButtonCaption}
                        Items={field.Items}
                        IsValid={field.IsValid}
                        ErrorMessage={field.ErrorMessage}
                    />
                }
                case 'Recaptcha': {
                    return <ReCaptchaField
                        key={index}
                        id={field.Key}
                        Required={field.Required}
                        Columns={field.Columns}
                        collectData={(label,value) => {this.props.collectData(this.props.Key, label, value)}}
                        SiteKey={field.SiteKey}
                        IsValid={field.IsValid}
                    />
                }
            }
        })
    }
}
export default FieldRenderer;

class MultipleItemsField extends BaseField{
    constructor(props) {
        super(props);
        this.createItem = this.createItem.bind(this);
        this.renderItems = this.renderItems.bind(this);
        this.toggleEditItem = this.toggleEditItem.bind(this);
        this.deleteItem = this.deleteItem.bind(this);
        this.collectItemsData = this.collectItemsData.bind(this);
        this.trackMultipleItemsInputData = this.trackMultipleItemsInputData.bind(this);
    }

    createItem(){
        let Fields = this.props.Fields.map(x => x);

        let TempArray = [];
        this.props.Template.Fields.forEach((field) => {
            let tmp = {
                'Key': field.Key,
                'Type': field.Type,
                'Label': field.Label,
                'Placeholder': field.Placeholder,
                'Columns': field.Columns,
                'Required': field.Required,
                'Value': field.Value,
                'ValueType': field.ValueType,
                'RenderBold': field.RenderBold,
                'InEditMode': field.InEditMode,
            }
            TempArray.push(tmp);
        })

        let Item = {
            'Fields': TempArray,
            'ID': Date.now()
        };
        Fields.push(Item);
        let newItem = {
            'ID': Date.now(),
            'action': 'add',
            'dataType': 'fields',
            'Fields': Fields,
        }
        this.props.collectData(this.props.id, newItem);
    }

    toggleEditItem(id){
        let itemToEdit = null;
        this.props.Fields.forEach(item => {
            if(item.ID === id){
                itemToEdit = item;
                itemToEdit.action = 'edit';
                itemToEdit.InEditMode = !itemToEdit.InEditMode;
            }
        })
        if(itemToEdit !== null){
            this.props.collectData(this.props.id, itemToEdit);
        }
    }

    deleteItem(id){
        let itemToDelete = null;
        this.props.Fields.forEach(item => {
            if(item.ID === id){
                itemToDelete = item;
                itemToDelete.dataType = 'fields';
                itemToDelete.action = 'delete';
            }
        })
        if(itemToDelete !== null){
            this.props.collectData(this.props.id, itemToDelete);
        }
    }

    collectItemsData(masterItemID, key, value){
        let items = this.props.Fields.map((item) => {
            if(item.ID === masterItemID){
                item.Fields.map(field => {
                    if(field.Key === key){
                        field.Value = value;
                    }
                    return field;
                })
            }
            return item;
        });
        this.props.collectData(this.props.Label, items);
    }

    trackMultipleItemsInputData(masterItemID, key){
        this.props.trackInput(key);
    }

    renderItems(){
        if(this.props.Fields === undefined){
            return null;
        }
        return this.props.Fields.map((item, index) => {
            return (
                <MultipleItemValue
                    key={index}
                    Key={item.ID}
                    ID={item.ID}
                    action={null}
                    toggleEditItem={this.toggleEditItem}
                    deleteItem={this.deleteItem}
                    Fields={item.Fields}
                    InEditMode={item.InEditMode}
                    collectData={this.collectItemsData}
                    trackInput={this.trackMultipleItemsInputData}
                />
            )
        })
    }

    render(){
        return(
            <div className="multipleitems" id={this.props.id}>
                <div className="row">
                    {this.renderItems()}
                </div>
                <div className="row">
                    <div className="col-12">
                        <button type="button" className="add btn btn-primary" onClick={this.createItem}>
                            {this.props.ButtonCaption}
                        </button>
                    </div>
                </div>
                {this.renderErrorMessage()}
            </div>
        )
    }
}

class MultipleItemValue extends FieldRenderer{
    constructor(props) {
        super(props);
    }

    renderFieldsOrContent(){
        if(this.props.InEditMode){
            return this.renderFields();
        }
        let fields = this.props.Fields.map((field, index) => {
            switch(field.Type) {
                case 'Text': {
                    let boldClass = 'd-block ';
                    if(field.RenderBold){
                        boldClass += ' font-extrabold';
                    }
                    return (
                        <div className="row" key={index}>
                            <div className="col-md-6 col-lg-4">
                                <label className={boldClass}>
                                    {field.Label}
                                </label>
                            </div>
                            <div className="col-md-6 col-lg-4">
                                <span className={boldClass}>
                                    {field.Value}
                                </span>
                            </div>
                        </div>
                    )
                }
            }
        });
        return (
            <div className="field__content">
                {fields}
            </div>
        )
    }

    renderEditSaveButtonText(){
        if(this.props.InEditMode){
            return 'Speichern';
        }
        return 'Bearbeiten'
    }

    render(){
        return(
            <div className="mb-3 mb-md-4 multi__item--value">
                <div className="bg-grey h-100 p-3 p-md-4 position-relative">
                    <div className="row">
                        {this.renderFieldsOrContent()}
                        <div className="text-end multi__item--buttons col-12">
                            <button type="button" className="edit__save btn btn-primary" onClick={(e) => this.props.toggleEditItem(this.props.ID, this.props.Fields)}>
                                {this.renderEditSaveButtonText()}
                            </button>
                            <button type="button" className="delete btn btn-secondary" onClick={(e) => this.props.deleteItem(this.props.ID)}>
                                löschen
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
